import React, { useState } from "react";
import PropTypes from "prop-types";
import "../css/theme.css";
import "../css/addCreditor.css";

const AddCreditor = ({ onSubmit }) => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSpecial, setIsSpecial] = useState(false);
  const [committedAmount, setCommittedAmount] = useState("");

  const [contact2, setContact2] = useState("");
  const [designation2, setDesignation2] = useState("");
  const [whatsapp2, setWhatsapp2] = useState("");

  const [contact3, setContact3] = useState("");
  const [designation3, setDesignation3] = useState("");
  const [whatsapp3, setWhatsapp3] = useState("");

  const [contact4, setContact4] = useState("");
  const [designation4, setDesignation4] = useState("");
  const [whatsapp4, setWhatsapp4] = useState("");

  const [preferredBank, setPreferredBank] = useState("");
  const [holdingLimit, setHoldingLimit] = useState("");
  const [creditDays, setCreditDays] = useState("");
  const [notes, setNotes] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const isTenDigitOrEmpty = (val) =>
    val.trim() === "" || /^\d{10}$/.test(val.trim());

  const validateInputs = () => {
    if (!name.trim()) {
      setError("Name is required.");
      return false;
    }
    if (!address.trim()) {
      setError("Address is required.");
      return false;
    }
    if (!/^\d{10}$/.test(phoneNumber.trim())) {
      setError("Phone number must be exactly 10 digits.");
      return false;
    }

    if (isSpecial) {
      if (!committedAmount || isNaN(committedAmount)) {
        setError("Committed amount is required for special creditors.");
        return false;
      }
      if (Number(committedAmount) <= 0) {
        setError("Committed amount must be greater than 0.");
        return false;
      }
    }

    if (holdingLimit && (isNaN(holdingLimit) || Number(holdingLimit) < 0)) {
      setError("Holding limit must be a positive number.");
      return false;
    }

    if (creditDays && (!Number.isInteger(Number(creditDays)) || Number(creditDays) < 0)) {
      setError("Credit days must be a non-negative whole number.");
      return false;
    }

    // Optional WhatsApp fields: if filled, must be 10 digits
    if (!isTenDigitOrEmpty(whatsapp2)) {
      setError("WhatsApp 2 must be 10 digits if provided.");
      return false;
    }
    if (!isTenDigitOrEmpty(whatsapp3)) {
      setError("WhatsApp 3 must be 10 digits if provided.");
      return false;
    }
    if (!isTenDigitOrEmpty(whatsapp4)) {
      setError("WhatsApp 4 must be 10 digits if provided.");
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    const confirmSubmit = window.confirm("Are you sure you want to submit?");
    if (!confirmSubmit) return;

    // IMPORTANT: keys here match DB columns
    const creditor = {
      name: name.trim(),
      address: address.trim(),
      phone_number: phoneNumber.trim(),
      is_special: isSpecial ? 1 : 0,
      committed_amount: isSpecial ? parseFloat(committedAmount) : null,

      contact_name2: contact2 || null,
      designation2: designation2 || null,
      whatsapp2: whatsapp2 || null,

      contact_name3: contact3 || null,
      designation3: designation3 || null,
      whatsapp3: whatsapp3 || null,

      contact_name4: contact4 || null,
      designation4: designation4 || null,
      whatsapp4: whatsapp4 || null,

      preferred_bank: preferredBank || null,
      holding_limit: holdingLimit ? parseFloat(holdingLimit) : null,
      credit_days: creditDays ? parseInt(creditDays, 10) : null,
      notes: notes || null,
    };

    try {
      const response = await fetch("/api/creditors.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(creditor),
      });

      if (!response.ok) {
        throw new Error("Failed to add creditor. Please try again.");
      }

      const newCreditor = await response.json();

      setSuccess("Creditor added successfully!");
      setTimeout(() => setSuccess(""), 2000);

      // Reset all fields
      setName("");
      setAddress("");
      setPhoneNumber("");
      setIsSpecial(false);
      setCommittedAmount("");

      setContact2("");
      setDesignation2("");
      setWhatsapp2("");

      setContact3("");
      setDesignation3("");
      setWhatsapp3("");

      setContact4("");
      setDesignation4("");
      setWhatsapp4("");

      setPreferredBank("");
      setHoldingLimit("");
      setCreditDays("");
      setNotes("");

      if (onSubmit) onSubmit(newCreditor);
    } catch (err) {
      setError(err.message || "Error submitting creditor.");
    }
  };

  return (
    <div className="ac-container">
      <h2 className="ac-title">Add Creditor</h2>

      {error && <div className="ac-alert ac-alert-danger">{error}</div>}
      {success && <div className="ac-alert ac-alert-success">{success}</div>}

      <form onSubmit={handleSubmit} className="ac-form">
        {/* Primary Section */}
        <div className="ac-section">
          <h4>Primary Details</h4>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Phone Number</label>
              <input
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Address</label>
              <input
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>

          <label className="ac-checkbox">
            <input
              type="checkbox"
              checked={isSpecial}
              onChange={(e) => setIsSpecial(e.target.checked)}
            />
            Special Creditor (Committed Amount Required)
          </label>

          {isSpecial && (
            <div className="ac-field">
              <label>Committed Amount</label>
              <input
                type="number"
                value={committedAmount}
                onChange={(e) => setCommittedAmount(e.target.value)}
              />
            </div>
          )}
        </div>

        {/* Contacts */}
        <div className="ac-section">
          <h4>Other Contacts</h4>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Contact 2</label>
              <input
                value={contact2}
                onChange={(e) => setContact2(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>Designation 2</label>
              <input
                value={designation2}
                onChange={(e) => setDesignation2(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>WhatsApp 2</label>
              <input
                value={whatsapp2}
                onChange={(e) => setWhatsapp2(e.target.value)}
              />
            </div>
          </div>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Contact 3</label>
              <input
                value={contact3}
                onChange={(e) => setContact3(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>Designation 3</label>
              <input
                value={designation3}
                onChange={(e) => setDesignation3(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>WhatsApp 3</label>
              <input
                value={whatsapp3}
                onChange={(e) => setWhatsapp3(e.target.value)}
              />
            </div>
          </div>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Contact 4</label>
              <input
                value={contact4}
                onChange={(e) => setContact4(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>Designation 4</label>
              <input
                value={designation4}
                onChange={(e) => setDesignation4(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>WhatsApp 4</label>
              <input
                value={whatsapp4}
                onChange={(e) => setWhatsapp4(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="ac-section">
          <h4>Additional Details</h4>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Preferred Bank</label>
              <input
                value={preferredBank}
                onChange={(e) => setPreferredBank(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Holding Limit</label>
              <input
                type="number"
                value={holdingLimit}
                onChange={(e) => setHoldingLimit(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Credit Days</label>
              <input
                type="number"
                value={creditDays}
                onChange={(e) => setCreditDays(e.target.value)}
              />
            </div>
          </div>

          <div className="ac-field">
            <label>Notes</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
        </div>

        <button type="submit" className="ac-btn">
          ➕ Add Creditor
        </button>
      </form>
    </div>
  );
};

AddCreditor.propTypes = {
  onSubmit: PropTypes.func,
};

export default AddCreditor;